import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgError = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 24, cy: 24, r: 23.5, fill: "#FDF4F6", stroke: "#DA2F58" }),
  /* @__PURE__ */ jsx("path", { d: "M25.5011 15H22.2284L22.499 27.3465H25.222L25.5011 15ZM23.8605 32.6744C24.8584 32.6744 25.7125 31.8377 25.7209 30.796C25.7125 29.7714 24.8584 28.9346 23.8605 28.9346C22.8288 28.9346 21.9916 29.7714 22.0001 30.796C21.9916 31.8377 22.8288 32.6744 23.8605 32.6744Z", fill: "#DA2F58" })
] });
const ForwardRef = forwardRef(SvgError);
export { ForwardRef as ReactComponent };
